module.exports = ".amd-simple-table-show-all {\n  background-color: #f6f6f6;\n  margin: 32px;\n  font-size: 15px;\n  text-align: center;\n  color: #005c80; }\n"